export default __webpack_public_path__ + "images/751abd763da834ab2ce46d62f5fcc70c-apple-pay-logo-small.svg";